import { messageLayoutTokens } from '@/shared/theme/message-layout';
import type { SxProps, Theme } from '@mui/material';

/**
 * Calculates dynamic border radius for message bubbles based on grouping
 * Outer corners stay rounded, inner corners (grouped) become subtle
 * @param isOwn - Whether message is from current user
 * @param hideName - Whether name is hidden (grouped top)
 * @param hideAvatar - Whether avatar is hidden (grouped bottom)
 * @returns SxProps with border radius values
 */
export function getMessageBorderRadius(isOwn: boolean, hideName: boolean, hideAvatar: boolean): SxProps<Theme> {
  const { default: defaultRadius, grouped: groupedRadius } = messageLayoutTokens.borderRadius;
  const side = isOwn ? 'Right' : 'Left';

  return {
    [`borderTop${side}Radius`]: hideName ? groupedRadius : defaultRadius,
    [`borderBottom${side}Radius`]: hideAvatar ? groupedRadius : defaultRadius
  };
}

/**
 * Gets transition style for message animations
 * @returns CSS transition string
 */
export function getMessageTransition(): string {
  const { duration, easing } = messageLayoutTokens.transition;
  return `transform ${duration}ms ${easing}, background-color ${duration / 2}ms ${easing}`;
}
